
<ng-container *ngIf="isLoaded">
  <div class="modal-close-btn" (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Редакция на Доставчик на Услуга</h5>
        <p class="text-center small">Моля, направете нужните промени</p>
      </div>


      <!-- Bordered Tabs Justified -->
      <ul class="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
        <li class="nav-item flex-fill" role="presentation">
          <button class="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Основни Данни</button>
        </li>
        <li class="nav-item flex-fill" role="presentation">
          <button class="nav-link w-100" id="profile-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Услуги</button>
        </li>
      </ul>
      <div class="tab-content pt-2" id="borderedTabJustifiedContent">
        <div class="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab">
          <form [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
            <div class="col-12">
              <label for="serviceProviderName" class="form-label">Име</label>
              <input type="text" formControlName="serviceProviderName" class="form-control" id="serviceProviderName" value="{{editObject.serviceProviderName}}">
            </div>
            <div class="col-12">
              <label for="serviceProviderEIK" class="form-label">ЕИК</label>
              <input type="text" formControlName="serviceProviderEIK" class="form-control" id="serviceProviderEIK" value="{{editObject.serviceProviderEIK}}">
            </div>
            <div class="col-12">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
                <label class="form-check-label" for="isActive">Активна</label>
              </div>
            </div>
            <div class="col-12">
              <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Промени</button>
            </div>
          </form>
        </div>
        <div class="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab">
          <div style="display: flex; justify-content: end;">
            <button type="button" style="margin-right: 10px;" class="btn btn-primary" (click)="onCreation()"><i class="bi bi-check-circle"></i> Добави</button>
            <button type="button" style="margin-right: 10px;" class="btn btn-warning" (click)="onEdit()" [disabled]="!selectedService"><i class="bi bi-exclamation-triangle"></i> Редактирай</button>
            <button type="button" class="btn btn-danger" (click)="onDelete()" [disabled]="!selectedService"><i class="bi bi-exclamation-octagon"></i> Изтриване</button>
          </div>
          <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 15px; margin-top: 20px;">
            <!-- Search input box -->
            <input type="text" [(ngModel)]="searchQuery" class="form-control" placeholder="Search..." style="flex: 1; margin-right: 10px;">

            <!-- Search button -->
            <button (click)="filterServices()" class="btn btn-primary">Search</button>
          </div>
          <table class="table table-hover" style="table-layout: fixed; width: 100%;">
            <thead>
              <tr>
                <th scope="col" style="width: 80px;">УРИ</th>
                <th scope="col" style="width: 100px;">Име</th>
                <th scope="col" style="width: 120px;">Услуга</th>
                <th scope="col" style="width: 80px;">Такса</th>
                <th scope="col" style="width: 140px;">Банкова сметка</th>
                <th scope="col" style="width: 80px;">Образец</th>
                <th scope="col" style="width: 90px;">Тип срок</th>
                <th scope="col" style="width: 60px;">Активна</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let service of filteredServices" [ngClass]="!isSelected(service)?'':'selected-cell'" (click)="onUserSelected(service)">
                <td [title]="service.service.yri" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{service.service.yri}}</td>
                <td [title]="service.title" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{service.title}}</td>
                <td [title]="service.service.serviceName" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{service.service.serviceName}}</td>
                <td>{{service.deliverTaxe}}</td>
                <td [title]="getFullBankDetails(service)" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{getBankDetails(service)}}</td>
                <td [title]="service.sample" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{service.sample || '-'}}</td>
                <td>{{getServiceTermTypeLabel(service.serviceTermTypeId)}}</td>
                <td>{{service.isActive}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div><!-- End Bordered Tabs Justified -->



    </div>
  </div>

</ng-container>
